// Case-insensitive "contains" match on the template name, shared by the template
// pickers (Header "Add templates" and the zero-state ISN picker). Leading/trailing
// whitespace in the query is ignored; a blank query matches every named template.
export const filterTemplatesByName = (templates, searchQuery) => {
  const normalizedQuery = searchQuery.trim().toLowerCase();
  return templates?.filter((template) => template?.name?.toLowerCase().includes(normalizedQuery));
};
